import React from 'react';
import ScarecrowImage from '../../images/scarecrow.svg';
import styled from 'styled-components';
import qs from "query-string";
import Typography from './Typography';
import Button from './Button';

interface Props /* extends StateProps, RouteComponentProps */ {
  location: any;
  t: any;
}

const NotAvailable: React.FC<Props> = ({
  location,
}) => {
  const searchParams = location.search
    ? { ...qs.parse(location.search) } as any
    : {};

  function renderTitle() {
    const customMessage = searchParams.custom;

    switch(customMessage) {
    case 'invitation':
      return /* t */('Invitation not available');
    default:
      return /* t */('Not found');
    }
  }

  function renderMessage() {
    const customMessage = searchParams.custom;

    switch(customMessage) {
    case 'invitation':
      return /* t */('The link is no longer available, contact your agent');
    default:
      return null;
    }
  }


  function renderButton() {
    const customMessage = searchParams.custom;

    let redirectLink;
    let title;

    switch(customMessage) {
    case 'invitation':
      title = /* t */('Create an account');
      redirectLink = `/actor`;
      break;
    default:
      title = ('Go back');
      redirectLink = `${process.env.REACT_APP_CWB_Site}`;
      break;
    }

    return (
      <ContinueButton
        href={redirectLink}
        onClick={(e: any) => {
          e.preventDefault();
          window.top.location.href = e.target.href;
        }}
      >{title}</ContinueButton>
    );
  }

  return (
    <Background>
      <HeroImage src={ScarecrowImage} height={210} />
      <Title variant='h1'>{renderTitle()}</Title>
      <Description>{renderMessage()}</Description>
      {/* <Description>{t('There-s no offer available for this account at the moment')}</Description> */}
      {renderButton()}
    </Background>
  );
}

const Background = styled.div`
  background-color: white;
  width: 100%;
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  @media all and (max-width: 520px) {
    padding-top: 0;
  }
`;

const Modal = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;

  max-width: 480px;
  min-width: 480px;
  padding: 40px 20px;
  border-radius: 4px;

  @media all and (max-width: 520px) {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    width: 100%;
    min-width: 40%;
    padding: 40px;
  }
`;

const HeroImage = styled.img``;

const Title = styled(Typography)`
  font-weight: 600;
  // margin: 24px 0;
  margin-top: 24px;
  max-width: 400px;
`;

const Description = styled(Typography)`
  margin: 24px 0;
  text-align: center;
  line-height: 26px;
  max-width: 400px;
`;

const ContinueButton = styled.a<{ as?: string, href: string }>`
  width: 100%;
  max-width: 360px;
  padding: 13px 0;
  font-size: 14px;
  border-radius: 5px;
  font-weight: 700;
  text-align: center;

  background-color: #0F9BF0;

  &,
  &:link,
  &:visited{
    color: white;
    text-decoration: none;
  }
`;

export default NotAvailable;
